export default "__VITE_ASSET__DidB6lMX__"